export default [
	{
		path: "/admin/users",
		exact: true,
		policy: "superAdminAuth",
		component: "AdminUsers",
		mui: true,
	},
];
